import { Component, ElementRef, ViewChild } from '@angular/core';
import { Location } from "@angular/common";
import { UploadService } from "../../../services/upload.service";
import { ActivatedRoute } from "@angular/router";
import { ConnectionService } from "../../../services/connection.service";
import { AuthService } from "../../../services/auth.service";
import { global } from '../../../services/global';

@Component({
    selector: 'app-albaran-upload-photo',
    templateUrl: './albaran-upload-photo.component.html',
    styleUrls: ['./albaran-upload-photo.component.scss'],
    standalone: false
})
export class AlbaranUploadPhotoComponent {

    name = "";

    @ViewChild('buttonModal') buttonModal!: ElementRef;

    url = global.getUrl();
    scanResult: any;
    documents: any;
    idAlbara: any;
    base64: any;
    base64Original: any;
    unescannedImage: any;
    imageChangedEvent: any = '';
    croppedImage: any = '';

    close = false;
    showAlertUploadFoto = false;
    buttonHidden: boolean = true;
    scannSuccess: boolean = false;
    showLoader: boolean = false;
    isCroppedImage: boolean = false;

    messageAlertUploadFoto: string = "";
    // Motivo por el que no hay documentos que enseñar (sesión caducada, albarán ajeno, sin cobertura)
    messageError: string = "";

    constructor(
        private location: Location,
        private uploadService: UploadService,
        private route: ActivatedRoute,
        public connection: ConnectionService,
        private auth: AuthService
    ) {
    }

    /**
     * URL de descarga de un documento. El token va en la URL porque <img> y <a> no pueden mandar
     * la cabecera Authorization, y el backend ya no sirve documentos sin identificar.
     */
    downloadUrl(documentId: string | number): string {
        const token = encodeURIComponent(this.auth.getToken() ?? '');

        return this.url + 'xofers/download?id=' + documentId + '&token=' + token;
    }

    // 401: la sesión ha caducado. 404: el albarán ya no es de este xofer (o no existe).
    downloadErrorMessage(error: any): string {
        if (this.connection.reportError(error)) {
            return "Sin conexión: no se pueden cargar los documentos hasta recuperar cobertura.";
        }

        if (error?.status === 401) {
            return "Tu sesión ha caducado. Vuelve a identificarte para ver los documentos.";
        }

        if (error?.status === 404) {
            return "Este albarán ya no está asignado a ti, así que no se pueden ver sus documentos.";
        }

        return error?.error?.message ?? "No se han podido cargar los documentos.";
    }

    ngOnInit(): void {
        this.route.params.subscribe(
            (params) => {
                this.idAlbara = params['idAlbara'];
                this.name = "Documentación albarán - " + params['idAlbara'];
            }
        );

        this.showLoader = true;

        this.uploadService.getFiles(this.idAlbara).subscribe(
            {
                next: doc => {
                    this.documents = doc.documents;
                    this.messageError = "";
                    this.connection.reportSuccess();
                    this.showLoader = false;
                }, error: error => {
                    // Sin esto el loader se quedaba girando para siempre
                    this.documents = [];
                    this.messageError = this.downloadErrorMessage(error);
                    this.showLoader = false;
                }
            }
        )
    }

    checkImage(event: Event) {
        let input = event.target as HTMLInputElement;

        if (!input.files || !input.files[0]) {
            // TODO: Añadir mensaje de excepcion si no llega archivo (Un pop up por ejemplo)
            return false;
        }

        let file = input.files[0];

        if (!file) {
            this.messageAlertUploadFoto = "No existe documento, recargue la página y vuelva a intentarlo.";
            this.showAlertUploadFoto = !this.showAlertUploadFoto;
        } else {
            if (file.type.startsWith('image/')) {
                this.imageChangedEvent = event;
                this.buttonModal.nativeElement.click();
            } else if (
                file.type === 'application/pdf' ||
                file.type === 'application/msword' ||
                file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            ) {
                this.uploadService.uploadFilesDocs(file, this.idAlbara, "doc").subscribe(
                    next => {
                        this.messageAlertUploadFoto = next.message;
                        this.showAlertUploadFoto = !this.showAlertUploadFoto;
                        this.ngOnInit();
                    },
                    error => {
                        this.messageAlertUploadFoto = error.message;
                        this.showAlertUploadFoto = !this.showAlertUploadFoto;
                    }
                );
            } else {
                this.messageAlertUploadFoto = "El archivo que has subido no es correcto, tiene que ser un documento o una imagen. Recargue e inténtelo de nuevo.";
                this.showAlertUploadFoto = !this.showAlertUploadFoto;
            }
        }

        return true;
    }

    imageCropped(event: any): void {
        this.croppedImage = event.objectUrl;
    }

    cropImage() {
        this.isCroppedImage = true;
    }

    uploadImage(): void {
        this.showLoader = true;

        fetch(this.croppedImage)
            .then(response => response.blob())
            .then(blob => {
                const reader = new FileReader();
                reader.onload = () => {
                    if (!reader.result) {
                        // TODO: Añadir mensaje de excepcion si no llega archivo (Un pop up por ejemplo)
                        return false;
                    }

                    if (typeof reader.result === "string") {
                        const base64 = reader.result.split(',')[1];

                        this.uploadService.uploadFiles(base64, this.idAlbara, "documentos").subscribe(
                            {
                                next: next => {
                                    this.messageAlertUploadFoto = next.message;
                                    this.showAlertUploadFoto = !this.showAlertUploadFoto;
                                    this.showLoader = false;

                                    this.ngOnInit();
                                }, error: error => {
                                    this.messageAlertUploadFoto = error.message;
                                    this.showAlertUploadFoto = !this.showAlertUploadFoto;

                                    this.showLoader = false;
                                }
                            }
                        );
                    }

                    return true;
                };
                reader.readAsDataURL(blob);
            })
            .catch(error => {
                console.error("Error al convertir Object URL en Base64: " + error);
            });
    }

    closeAlertError() {
        this.showAlertUploadFoto = !this.showAlertUploadFoto;
    }
}
